export default __webpack_public_path__ + "static/behance-19c5daf35b16d070d5e0e968581d19ee.svg";